export var VisitorVariationUpdateParam;
(function (VisitorVariationUpdateParam) {
    VisitorVariationUpdateParam["NewNavigation"] = "newNavigation";
})(VisitorVariationUpdateParam || (VisitorVariationUpdateParam = {}));
export var QAEventSdkName;
(function (QAEventSdkName) {
    QAEventSdkName["SDK_ALLOCATED_VARIATIONS"] = "sdk:allocated-variations";
    QAEventSdkName["SDK_EXPOSED_VARIATIONS"] = "sdk:exposed-variations";
    QAEventSdkName["SDK_HIT_SENT"] = "sdk:hit-sent";
})(QAEventSdkName || (QAEventSdkName = {}));
export var QAEventQaAssistantName;
(function (QAEventQaAssistantName) {
    QAEventQaAssistantName["QA_READY"] = "qa:ready";
    QAEventQaAssistantName["QA_CLOSE"] = "qa:close";
    QAEventQaAssistantName["QA_RESET_FORCED_VARIATIONS"] = "qa:reset-forced-variations";
    QAEventQaAssistantName["QA_MINIMIZE_QA_ASSISTANT"] = "qa:minimize-qa-assistant";
    QAEventQaAssistantName["QA_TRIGGER_RENDER"] = "qa:trigger-render";
    QAEventQaAssistantName["QA_APPLY_FORCED_VARIATIONS"] = "qa:apply-forced-variations";
    QAEventQaAssistantName["QA_APPLY_FORCED_ALLOCATION"] = "qa:apply-forced-allocation";
    QAEventQaAssistantName["QA_APPLY_FORCED_UNALLOCATION"] = "qa:apply-forced-unallocation";
    QAEventQaAssistantName["QA_REMOVE_FORCED_VARIATION"] = "qa:remove-forced-variation";
})(QAEventQaAssistantName || (QAEventQaAssistantName = {}));
